<template>
  <v-sheet class="text-start">
    <page-head title="Workdays" :breadcrumb="['Shop', 'Workdays']">
      <template v-slot>
        <v-btn
          variant="outlined"
          color="primary"
          :to="{ name: 'workdayCreate' }"
          ><v-icon>mdi-plus</v-icon>Create Workday</v-btn
        >
      </template>
    </page-head>
    <v-data-table-server
      :items="dataTable.items"
      :items-per-page="dataTable.itemsPerPage"
      :items-length="dataTable.totalItems"
      :headers="dataTable.headers"
      :loading="dataTable.isLoading"
      :items-per-page-options="dataTable.itemsPerPageOptions"
      @update:options="updateWorkday"
    >
      <template v-slot:[`item.name`]="{ value, item }">
        <a :href="`/management/workday/id-${item.id}`">{{ value }}</a></template
      ></v-data-table-server
    >
  </v-sheet>
</template>

<script setup>
import PageHead from "@/components/admin_theme/PageHead.vue";
import { reactive } from "vue";
import { authAxios } from "@/util/Axios";
import { DEFAULT_DATATABLE } from "@/util/List";

const axios = authAxios();
const dataTable = reactive({
  headers: [
    { title: "Date", key: "date", align: "start", sortable: false },
    { title: "Branchs", key: "branch_names", align: "start", sortable: false },
    { title: "Schedule", key: "schedule", align: "start", sortable: false },
  ],
  ...DEFAULT_DATATABLE,
});

function updateWorkday({ page, itemsPerPage }) {
  dataTable.isLoading = true;
  loadWorkday(page, itemsPerPage).then((response) => {
    dataTable.isLoading = false;
    dataTable.items = [...response.data.data];
    dataTable.totalItems = response.data.total_items;
  });
}

function loadWorkday(page, length) {
  return axios({
    method: "GET",
    url: `${process.env.VUE_APP_BACKEND_URL}/api/workday/vuetify`,
    params: { page: page, length: length, search: "" },
  });
}
</script>
